import { FormWrapper } from 'components/formWrapper/formWrapper'
import { LoadingContainer } from 'components/loadingContainer'
import { useLocationById } from 'hooks/admin/useLocations/useLocations'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { LocationForm } from './locationForm'

export const LocationFormPage: React.FC = () => {
    const { id } = useParams<{ id?: string }>()
    const { data, isLoading, error } = useLocationById(id || '')
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const partnerId = searchParams.get('partnerId') || undefined
    const { data: orgData } = useOrganizations()
    const partnerName = React.useMemo(() => orgData?.find((org) => org.org_id === partnerId)?.name, [partnerId, orgData])

    const handleClose = () => {
        if (partnerId) {
            const url = `/admin/helyszinek/szervezet/${partnerId}`
            navigate(url)
        } else {
            navigate('/admin/helyszinek')
        }
    }

    useEffect(() => {
        if (id && !data && !isLoading) navigate('/hiba/404')
    }, [id, data, isLoading, navigate])

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <FormWrapper onClose={handleClose} partnerName={partnerName}>
                <LocationForm initialData={data} onClose={handleClose} partnerId={partnerId} />
            </FormWrapper>
        </LoadingContainer>
    )
}
